const transformDateFormat = date_format => {
  switch (date_format) {
    case '%m/%d/%Y':
      return 'MM/DD/YYYY'

    case '%m-%d-%Y':
      return 'MM-D-YYYY'

    case '%Y-%m-%d':
      return 'YYYY-MM-DD'

    case '%-d %b, %Y':
      return 'D MMM, YYYY'

    case '%-d %B, %Y':
      return 'D MMMM, YYYY'

    case '%A, %-d %B, %Y':
      return 'dddd, D MMMM, YYYY'

    case '%d/%m/%Y':
      return 'DD/MM/YYYY'

    case '%d %b, %Y':
      return 'DD MMM, YYYY'

    case '%b %d, %Y':
      return 'MMM DD, YYYY'

    default:
      return 'MM/DD/YYYY'
  }
}

const transformTimeFormat = time_format => {
  switch (time_format) {
    case '%I:%M %p':
      return 'hh:mm a'

    case '%r':
      return 'hh:mm:ss a'

    case '%R':
      return 'HH:mm'

    case '%T':
      return 'HH:mm:ss'

    default:
      return 'hh:mm a'
  }
}

export {transformDateFormat, transformTimeFormat}
